import { ApiSlugs, BetaRegistrationDto, BetaRegistrationId } from '@workspace/data-types';
import { ApiCaller } from '../../../../api-caller.service';
import { ApiConnector } from '../../../../api-connector.abstract-service';
import { BetaRegistrationTokenVaultsAdminConnector } from './token-vaults/beta-registration-token-vaults.connector';

export class BetaRegistrationAdminConnector extends ApiConnector<
  BetaRegistrationDto,
  BetaRegistrationDto,
  BetaRegistrationId
> {
  constructor(apiCaller: ApiCaller, betaRegistrationId: BetaRegistrationId, apiPrefix: string) {
    super(apiCaller, apiPrefix, `${ApiSlugs.BETA_REGISTRATION}/${betaRegistrationId}`);
  }

  tokenVaults = () =>
    new BetaRegistrationTokenVaultsAdminConnector(this.apiCaller, this.slug, this.apiPrefix);
}
